/* eslint-disable react/no-array-index-key */
import {DrugItemFormOptions} from '@/modules/drug-catalog/constants'
import {MedicationProfileCard} from '@/modules/drug-catalog/medication-profiles/components'
import {MedicationProfileFormSchema} from '@/modules/drug-catalog/medication-profiles/schemas'
import {FormSection} from '@cypro/ui/components/form/form-section'
import {EmptyState} from '@cypro/ui/components/ui/empty-state'
import {withForm} from '@cypro/ui/integrations/form'
import {Button, Grid, Text} from '@chakra-ui/react'
import {useStore} from '@tanstack/react-form'
import {useTranslate} from '@tolgee/react'
import {LuPlus} from 'react-icons/lu'
import {useId} from 'react'
import {FieldRequiredIndicator} from '@cypro/ui/components'

export const MedicationProfilesSection = withForm({
  ...DrugItemFormOptions,
  props: {
    onAddMedicationProfile: () => {},
    onEditMedicationProfile: (_profile: MedicationProfileFormSchema, _index: number) => {},
    onDeleteMedicationProfile: (_index: number) => {},
  },
  render: function Render({form, onAddMedicationProfile, onEditMedicationProfile, onDeleteMedicationProfile}) {
    const {t} = useTranslate('common')
    const {t: tSubstances} = useTranslate('substances')

    const medicationProfiles = useStore(form.store, state => state.values.medicationProfiles)
    const field = useStore(form.store, state => state.fieldMeta.medicationProfiles)

    const errorId = useId()
    const hasError = field?.errors && field.errors.length > 0

    const action = (
      <Button size="sm" variant="ghost" colorPalette="cyan" onClick={() => onAddMedicationProfile()}>
        <LuPlus />
        {t('add_form')}
      </Button>
    )

    return (
      <FormSection
        label={
          <>
            {t('medicine_forms')} <FieldRequiredIndicator />
          </>
        }
        description={tSubstances('medicine_forms_description')}
        aria-invalid={hasError}
        aria-labelledby={hasError ? errorId : undefined}
      >
        {Boolean(medicationProfiles.length) && (
          <Grid gridTemplateColumns="1fr 1fr" gapX="4" gapY="4">
            {medicationProfiles.map((profile, index) => (
              <MedicationProfileCard
                key={index}
                profile={profile}
                onEdit={() => onEditMedicationProfile(profile, index)}
                onDelete={() => onDeleteMedicationProfile(index)}
              />
            ))}
          </Grid>
        )}

        {!medicationProfiles.length && (
          <EmptyState title={t('no_medicine_forms_added_yet')} p="0">
            {action}
          </EmptyState>
        )}

        {hasError && (
          <Text fontSize="sm" color="fg.error" id={errorId}>
            {t('at_least_one_medicine_form_required')}
          </Text>
        )}

        {Boolean(medicationProfiles.length) && action}
      </FormSection>
    )
  },
})
